<template>
  <component :is="element" v-bind="properties" class="ProductCard__ContentFrame">
    <div class="ProductCard__ContentFrame-Inner">
      <div v-if="hasCta" class="ProductCard__ContentFrame-Cta">
        <button class="button button--rounded button--tertiary-b">
          {{ content.cta_text.value }}
        </button>
      </div>
      <button v-if="hasControls" class="ProductCard__VideoBtn" @click="emits('handlePlayClick', !playing)">
        <Icon :icon="playing ? 'video-pause' : 'video-play'" />
      </button>
    </div>
  </component>
</template>

<script setup>
import { computed } from 'vue';

import Icon from '../Global/Icon.vue';

const emits = defineEmits(['handlePlayClick']);

const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  element: {
    type: String,
    default: 'div',
  },
  properties: {
    type: Object,
    default: () => ({}),
  },
  playing: {
    type: Boolean,
  },
});

const hasCta = computed(() => {
  const content = props.content;
  const value = content?.cta_text?.value || '';
  const enabled = value && value.trim() !== '';

  return enabled;
});

const hasControls = computed(() => {
  const content = props.content;

  const value = content?.video_controls?.value || false;
  const enabled = JSON.parse(value);

  return enabled;
});
</script>
